export default __webpack_public_path__ + "75d925570fd2fed844c9f4c593f65d4a.png";